import { render } from "./SystemNotification.vue?vue&type=template&id=f8ae7c68"
import script from "./SystemNotification.vue?vue&type=script&lang=js"
export * from "./SystemNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__